import { SiteShell } from "@/components/site/SiteShell";
import { PageHero } from "@/components/site/PageHero";
import { SEO, breadcrumbSchema } from "@/components/site/SEO";
import { PRESS } from "@/lib/siteData";
import { ROUTE_SEO } from "@/lib/routeSeo";
import { ExternalLink } from "lucide-react";

export default function Press() {
  return (
    <SiteShell>
      <SEO title={ROUTE_SEO["/press"].title} description={ROUTE_SEO["/press"].meta} path="/press" jsonLd={breadcrumbSchema([{name: "Home", path: "/"}, {name: "Press"}])} />
      <PageHero kicker="Press" title={ROUTE_SEO["/press"].h1} subtitle="Selected features and industry recognition over the past 24 months." breadcrumb={[{name: "Home", path: "/"}, {name: "Press"}]} />
      <section className="section-pad">
        <div className="container-site">
          <ul className="divide-y divide-border border border-border rounded-2xl overflow-hidden bg-card">
            {PRESS.map((p, i) => (
              <li key={i} className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-6 py-6 sm:py-8">
                <div>
                  <div className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--primary))]">{p.year} · {p.outlet}</div>
                  <div className="mt-1 font-display text-xl sm:text-2xl uppercase tracking-[0.02em] text-foreground">{p.title}</div>
                </div>
                {p.url && (
                  <a href={p.url} target="_blank" rel="noreferrer noopener" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-foreground hover:text-[hsl(var(--primary))]">Read <ExternalLink className="h-3.5 w-3.5" /></a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </SiteShell>
  );
}
